import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { buildInfo } from './build-info';
import { environment } from './environments/environment';

(window as unknown as { __KIRIGAMI_BUILD__: typeof buildInfo }).__KIRIGAMI_BUILD__ = buildInfo;

if (environment.stage === 'prod') {
  // One bundle ships to every environment (runtime resolver), so console
  // suppression must happen at runtime too. `console.error` is kept so real
  // failures (Angular's ErrorHandler) stay diagnosable; build info remains
  // available via window.__KIRIGAMI_BUILD__.
  const noop = (): void => undefined;
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.trace = noop;
  console.warn = noop;
} else {
  console.log(
    `%c[Kirigami] %cbuild=${buildInfo.commitShortSha} (${buildInfo.branch}) built=${buildInfo.buildTime}` +
      (buildInfo.pipelineId ? ` pipeline=${buildInfo.pipelineId}` : ''),
    'color:#346a95;font-weight:bold',
    'color:#4a5054',
  );
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
